import React from "react";

interface BaseIconProps {
  pathData: string;
  size?: string;
  className?: string;
  strokeWidth?: number;
  viewBox?: string;
  svgProps?: React.SVGProps<SVGSVGElement>;
  pathProps?: React.SVGProps<SVGPathElement>;
}

export const BaseIcon: React.FC<BaseIconProps> = ({
  pathData,
  size = "w-4 h-4",
  className = "",
  strokeWidth = 2,
  viewBox = "0 0 24 24",
  svgProps = {},
  pathProps = {},
}) => {
  const combinedClassName = `${size} ${className}`.trim();

  return (
    <svg
      className={combinedClassName}
      fill="none"
      stroke="currentColor"
      viewBox={viewBox}
      {...svgProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={strokeWidth}
        d={pathData}
        {...pathProps}
      />
    </svg>
  );
};
